import { WsRelationshipListButton } from '@workboard/ui-relationships';
import { ThemeProvider, ScopedCssBaseline, styled } from '@mui/material';
import { GlobalStyle, theme } from './theme/theme';

const StyledCssBaseline = styled(ScopedCssBaseline)({
  'body #new-related-work-area &, body #edit-related-work-area &': {
    // workaround for conflicts
    '& label': {
      top: '-10px',
      left: '-13px',
    },
  },
});

function WsRelationships(props: any) {
  const workboardUrl = window.location.origin + '/wb/vnext/okr';
  const isWsRelationshipEnabled = window?.wbConfig.isWSRelationshipEnabled || false;
  return (
    <StyledCssBaseline>
      <ThemeProvider theme={theme}>
        <GlobalStyle />
        {isWsRelationshipEnabled && props.id && (
            <WsRelationshipListButton id={props.id} baseUrl={workboardUrl} />
        )}
      </ThemeProvider>
    </StyledCssBaseline>
  );
}

export default WsRelationships;
